// extracted by mini-css-extract-plugin
export default {"badge":"styles--badge--1FFm6"};